import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SignatureService } from './signature.service';
import * as $ from 'jquery';
import { constants } from '../constants';
import { CommonUtilitiesService } from '../common-utilities.service';
declare var $: any;
@Component({
  selector: 'app-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss']
})
export class SignatureComponent implements OnInit {

  @Input('dataForPdf') dataForPdf;
  @Output('pdfOpened') pdfOpened = new EventEmitter();
  base64textString: any;
  //file input
  ACCEPT_FILES = constants.ACCEPT_IMG_FILES;
  isLoading = false;
  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  constructor(public LANG: CommonUtilitiesService, private serviceSignature: SignatureService) { }


  ngOnInit() {

    this.initEventsForCanvasDrawing();

  }

  convertToJsonDataPdf() {
    return {
      "givenName": this.dataForPdf.get('inputNames').value,
      "familyName": this.dataForPdf.get('inputLastNames').value,
      "identification": this.dataForPdf.get('inputCC').value,
      "msisdn": this.dataForPdf.get('inputNumber').value,
      "donorProvider": this.dataForPdf.get('inputOperator').value,
      "msisdnNotification": this.dataForPdf.get('inputAditionalNum').value,
      "annexedQuantity": "2",
      "nip": this.dataForPdf.get('inputCodeValidation').value,
      "isCurrentModalityPrepaid": this.dataForPdf.get('inputCurrentPlan').value,
      "firm": ""
    };
  }
  getPdf() {
    this.isLoading = true;
    const jsonData: any = this.convertToJsonDataPdf();
    if (this.dataForPdf.get('isShowCanvas').value) {
      const canvas = <HTMLCanvasElement>document.getElementById('canvas');
      canvas.toDataURL().replace('data:image/png;base64,', '');
      jsonData.firm = canvas.toDataURL().replace('data:image/png;base64,', '');
    } else {
      jsonData.firm = this.base64textString;
    }
    this.serviceSignature.getPdf(jsonData)
      .subscribe(
        (data => {

          if (data['responseCode'] != constants.SUCCESS_WS_RESPONSE_CODE) {
            this.modalTitle = this.LANG.getLangText('LABEL_ERROR');
            this.modalContent = this.LANG.getLangText('PORTABILITY_LABEL_MODAL_ERROR_SENDING_REQUEST');
            this.isShowModal = true;
            this.isLoading = false;
            return false;
          } else {
            const pdfBlob = this._base64ToArrayBuffer(data['obj'].attached);
            // create the blob object with content-type "application/pdf"               
            var blob = new Blob([pdfBlob], { type: "application/pdf" });
            var url = URL.createObjectURL(blob);
            if (navigator.appVersion.toString().indexOf('.NET') > 0) {
              window.navigator.msSaveBlob(blob, 'CI.pdf');
              window.navigator.msSaveOrOpenBlob(blob);
            }
            else {
              var link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.target = "_blank";
              link.click();
            }
            this.isLoading = false;
          }


        }),
        (err) => {

        }
      );
    this.pdfOpened.emit([true, jsonData.firm]);
  }

  cleanCanvas() {
    const canvas = <HTMLCanvasElement>document.getElementById('canvas');
    const context = canvas.getContext('2d');

    context.clearRect(0, 0, canvas.width, canvas.height);
    this.pdfOpened.emit(false);
  }
  _base64ToArrayBuffer(pdfBase64str) {
    const binary_string = atob(pdfBase64str.replace(/\s/g, ''));
    const len = binary_string.length;

    const bytes = new Uint8Array(len)
    // .map((byte, i) => binary_string.charCodeAt(i));
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  /**
  * Description: Método que abre la ventana de carga de archivos adjuntos
  * Autor: eciro
  * @param N/A
  * @return N/A
  */
  loadHiddenFile(id: string) {
    $("#" + id).click();
  }


  /**
   * @author eciro
   * Metodo que carga la imagen y la convierte a base64
   * @param evt 
   */
  handleFileSelect(evt) {
    this.pdfOpened.emit(false);
    let files = evt.target.files;
    let file = files[0];
    $('#inputFileSignatureFormFace').val(file.name);
    if (files && file) {
      let reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }
  _handleReaderLoaded(readerEvt) {
    let binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
  }

  hideModal() {
    this.isShowModal = false;
  }

  /**
   * @author eciro
   * Metodo que inicia los eventos que capturan lo que dibuja el usuario en canvas
   */
  initEventsForCanvasDrawing() {
    function getPosition(mouseEvent, sigCanvas) {
      let rect = sigCanvas.getBoundingClientRect();
      return {
        X: mouseEvent.clientX - rect.left,
        Y: mouseEvent.clientY - rect.top
      };
    }
    function initialize() {
      // get references to the canvas element as well as the 2D drawing context
      let sigCanvas = <HTMLCanvasElement>document.getElementById("canvas");
      let context = sigCanvas.getContext("2d");

      context.canvas.height = 150;
      context.strokeStyle = "#000000";
      context.lineJoin = "round";
      context.lineWidth = 2;

      //Inicializacion de ancho del canvas
      if ($('body').width() > 585) {
        context.canvas.width = 500;
      } else {
        context.canvas.width = $('body').width() - 86;
      }
      //evento que ajusta el ancho del canvas
      window.addEventListener('resize', function () {
        if ($('body').width() > 585) {
          context.canvas.width = 500;
        } else {
          context.canvas.width = $('body').width() - 86;
        }
      }, true);

      // create a function to pass touch events and coordinates to drawer
      function draw(event) {
        // get the touch coordinates.  Using the first touch in case of multi-touch
        var coors = {
          x: event.targetTouches[0].pageX,
          y: event.targetTouches[0].pageY
        };

        // Now we need to get the offset of the canvas location
        var obj: any = sigCanvas;

        if (obj.offsetParent) {
          // Every time we find a new object, we add its offsetLeft and offsetTop to curleft and curtop.
          do {
            coors.x -= obj.offsetLeft;
            coors.y -= obj.offsetTop;
          }
          // The while loop can be "while (obj = obj.offsetParent)" only, which does return null
          // when null is passed back, but that creates a warning in some editors (i.e. VS2010).
          while ((obj = obj.offsetParent) != null);
        }

        // pass the coordinates to the appropriate handler
        drawer[event.type](coors);
      }

      // This will be defined on a TOUCH device such as iPad or Android, etc.
      var is_touch_device = 'ontouchstart' in document.documentElement;

      if (is_touch_device) {
        // create a drawer which tracks touch movements
        var drawer = {
          isDrawing: false,
          touchstart: function (coors) {
            context.beginPath();
            context.moveTo(coors.x, coors.y);
            this.isDrawing = true;
          },
          touchmove: function (coors) {
            if (this.isDrawing) {
              context.lineTo(coors.x, coors.y);
              context.stroke();
            }
          },
          touchend: function (coors) {
            if (this.isDrawing) {
              this.touchmove(coors);
              this.isDrawing = false;
            }
          }
        };


        // attach the touchstart, touchmove, touchend event listeners.
        sigCanvas.addEventListener('touchstart', draw, false);
        sigCanvas.addEventListener('touchmove', draw, false);
        sigCanvas.addEventListener('touchend', draw, false);

        // prevent elastic scrolling
        sigCanvas.addEventListener('touchmove', function (event) {
          event.preventDefault();
        }, false);
      } else {

        // start drawing when the mousedown event fires, and attach handlers to
        // draw a line to wherever the mouse moves to
        $("#canvas").mousedown(function (mouseEvent) {
          var position = getPosition(mouseEvent, sigCanvas);
          context.moveTo(position.X, position.Y);
          context.beginPath();

          // attach event handlers
          $(this).mousemove(function (mouseEvent) {
            drawLine(mouseEvent, sigCanvas, context);
          }).mouseup(function (mouseEvent) {
            finishDrawing(mouseEvent, sigCanvas, context);
          }).mouseout(function (mouseEvent) {
            finishDrawing(mouseEvent, sigCanvas, context);
          });
        });

      }
    }

    // draws a line to the x and y coordinates of the mouse event inside
    // the specified element using the specified context
    function drawLine(mouseEvent, sigCanvas, context) {
      var position = getPosition(mouseEvent, sigCanvas);

      context.lineTo(position.X, position.Y);
      context.stroke();
    }

    // draws a line from the last coordiantes in the path to the finishing
    // coordinates and unbind any event handlers which need to be preceded
    // by the mouse down event
    function finishDrawing(mouseEvent, sigCanvas, context) {
      // draw the line to the finishing coordinates
      drawLine(mouseEvent, sigCanvas, context);

      context.closePath();

      // unbind any events which could draw
      $(sigCanvas).unbind("mousemove")
        .unbind("mouseup")
        .unbind("mouseout");
    }
    setTimeout(function () { initialize(); }, 1000);

  }
}


